import { token } from '@atlaskit/tokens';

import SwitcherItem from '@atlassian/switcher/item';

import { css } from '@compiled/react';

import { type JSX } from 'react/jsx-runtime';

const iconSkeletonStyles = css({
	display: 'inline-block',
	width: 32,
	height: 32,
	backgroundColor: token('color.skeleton', '#F4F5F7'),
	borderRadius: token('radius.large', '8px'),
});

const lineSkeletonStyles = css({
	display: 'inline-block',
	width: 98,
	height: 10,
	backgroundColor: token('color.skeleton', '#F4F5F7'),
	borderRadius: token('radius.small', '3px'),
});

const iconSkeleton = <div css={iconSkeletonStyles} />;

const lineSkeleton = <div css={lineSkeletonStyles} />;

// TODO: Export this as a primitive from Switcher instead of creating it here
export const SwitcherSkeletonItem = (): JSX.Element => {
	return (
		<SwitcherItem tag="li" icon={iconSkeleton} isDisabled>
			{lineSkeleton}
		</SwitcherItem>
	);
};
